import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { FileSharingRequestContractorContext } from "../components/Notifications/templates/FileSharingRequestContractor";

export const selectorFileSharingRequestContractorNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle === NotificationHandleType.FileSharingRequestContractor
    );
  }) as Array<WSNotificationResponse<FileSharingRequestContractorContext>>;
};
